define('IndependentDealersForm.View'
,	[
		'tavanoteam_independentdealersform_independentdealersform.tpl'
	,	'Backbone.FormView'	
	,	'Backbone.CompositeView'
	,	'TavanoTeam.IndependentDealersForm.Model'	
	,	'Backbone.CollectionView'
	,	'SC.Configuration'
	,	'Independent.Confirmation.View'
	, 	'Independent.IndividualPopup.View'
	,	'Utils'
	,	'jQuery'
	,	'underscore'
	]
,	function (
	tavanoteam_independentdealersform_independentdealersform
	,	BackboneFormView
	,	BackboneCompositeView	
	,	IndependentFormModel
	,	BackboneCollectionView	
	,	Configuration
	,	IndependentConfirmationView
	,	IndependentIndividualPopupView
	,	Utils
	,	jQuery
	,	_
	)
{
	'use strict';

	return Backbone.View.extend({

		template: tavanoteam_independentdealersform_independentdealersform
		,	
	
		initialize: function (options) {
			BackboneCompositeView.add(this);
			this.model = new IndependentFormModel();
			var self = this;
			
			this.model.fetch({
				data: { id: 204 }
			})
			.done(function(response) {
				self.render();
			});

			window.renderCaptchaLogin = _.bind(this.render, this);
			var url = 'https://www.google.com/recaptcha/api.js?onload=renderCaptchaLogin&render=explicit';
			this.captchaPromiseLogin = jQuery.getScript(url);


			this.application = options.application;
			BackboneFormView.add(this);
			this.model.on('save', jQuery.proxy(this, 'manageResponse'));
		},
		bindings: {
			'[name="firstname"]': 'firstname'
			,	'[name="lastname"]': 'lastname'
			,	'[name="email"]': 'email'
			,	'[name="comments"]': 'comments'
			,	'[name="city"]': 'city'
			,	'[name="company"]': 'company'
			,	'[name="phone"]': 'phone'	
			,	'[name="industry"]': 'industry'	
			,	'[name="annual_sales"]': 'annual_sales'	
			,	'[name="state"]': 'state'	
		},

		events: {
			'submit form': 'saveForm',
			'change [data-action="industry-selected"]': 'validateIndustry',
			'change [data-action="phone-validation"]': 'validatePhone',
			'change [data-action="email-validation"]': 'validateEmail'

		},
		render: function(){
			if(this.captchaPromiseLogin.state() === 'resolved'){
				var captchaId = '#independent-grecaptcha';
	
				Backbone.View.prototype.render.apply(this, arguments);
	
				try {
					grecaptcha.render(
						this.$el.find(captchaId)[0]
						, {
							'sitekey': '6Let2OUUAAAAAErTvwOMhTrGwSTBTpqVa-8al9rT'
						}
					);
				} catch (err) {
					console.log('Error rendering recaptcha: ', err);
				}
			}
		
		},

		manageResponse : function showSuccess(model) {	
			if (model.get("status") == 500){
				grecaptcha.reset();
				var isIndividual = model.attributes.industry ==  "8";
				if(isIndividual){
					var layout = this.application.getLayout();
					var independentIndividualPopupView = new IndependentIndividualPopupView({});
					layout.showInModal(independentIndividualPopupView,{});
					return
				}
				$("#email-error").show();
				$("#email-error").html(model.get("message"));

			}else if(model.get("status") == 400){
				grecaptcha.reset();
				$("#us-phone-error").show();
				return;
			}else if(model.get("status") == 200){
				this.showSuccess()
			}
		},
		validatePhone : function validatePhone(e){
			e.preventDefault();
			var target = this.$(e.target);
			var str = target[0].value;
			var patt = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g;
			var result = str.match(patt);

			if(!result && str != ''){
				target[0].className = "phone-input"
				$("#us-phone-error").show();
			}else{
				target[0].className = ""
				$("#us-phone-error").hide();
			}
		},
		validateEmail : function validateEmail(e){
			e.preventDefault();
			var target = this.$(e.target);
			$("#email-error").hide();
		},

		showSuccess : function showSuccess() {
			var layout = this.application.getLayout();
			var loyalityConfView = new IndependentConfirmationView({});
			layout.showInModal(loyalityConfView,{});
		},

		validateIndustry: function validateIndustry(e){

			e.preventDefault();
			var target = this.$(e.target);
			if(target[0].selectedIndex == 10){
				var layout = this.application.getLayout();
				var independentIndividualPopupView = new IndependentIndividualPopupView({});
				layout.showInModal(independentIndividualPopupView,{});
			}

		},

		defineValues: function defineValues(list, isState){
			var ret = [];
			if(!isState){
				_.each(list,function(element, i){
					var elementInfo = {
						internalId: element.valueid,
						isActive: false,
						label: element.value
					}
					ret.push(elementInfo);
				})
			}else{
				_.each(list,function(element, i){
					var elementInfo = {
						internalId: element.code,
						isActive: false,
						label: element.name
					}
					ret.push(elementInfo);
				})
			}
			
			return ret;
		},

		getContext: function getContext()
		{
			var self = this;
			var industry = this.defineValues(self.model.attributes.industry);
			var states = this.defineValues(SC.ENVIRONMENT.siteSettings.countries["US"].states, true);
			
			return {
				industrySelectValues: industry,
				states: states
			};
		},
		
	});
});
